import GoogleAnalytics from "./googleAnalytics4";
import moment from "moment"

const TAG = "ENLM"
export default class PerformanceAnalytics {
constructor(){
this.performanceAnalytics = new GoogleAnalytics()
}

processResourceEntry(entry){
    let modifiedEntry = {
        startTime: entry.startTime,
        duration: entry.duration,
        entryType: entry.entryType,
        eventTimestampMillis: moment().valueOf()
    }
    return modifiedEntry
}

processMeasureEntry(entry){
    let modifiedEntry = {
        name: entry.name,
        startTime: entry.startTime,
        duration: entry.duration,
        entryType: entry.entryType,
        eventTimestampMillis: moment().valueOf()
    }
    return modifiedEntry
}

reportPerformanceEventToGa(type, eventTimestampMillis, name, duration, startTime=0) {
const eventName = 'triggerPerformanceEvent'
    const dataLayer = {
        perfEntryName: name,
        perfEntryTimestamp: startTime,
        perfEntryType: type,
        perfEntryDuration: duration,
        eventTimestampMillis
    }
this.performanceAnalytics.gaEventTrigger(eventName,dataLayer)
}

reportEntry(entry){
    this.reportPerformanceEventToGa(entry.entryType, moment().valueOf(), entry.name, entry.duration, entry.startTime)
}

reportMeasure(entry,additionalTime){
    this.reportPerformanceEventToGa(entry.entryType, moment().valueOf(), entry.name, additionalTime+entry.duration || entry.duration , entry.startTime)
}

mark(name, markOptions){
    performance.mark(`${TAG}${name}`, markOptions);
}

measure(measureName, startMark, endMark){
    return performance.measure(`${TAG}${measureName}`, startMark?`${TAG}${startMark}`:undefined, endMark);
}

clearMarks(name){
    if(name) {
        performance.clearMarks(`${TAG}${name}`)
    }else {
        performance.clearMarks()
    }
}
clearMeasures(name){
    if(name) {
        performance.clearMeasures(`${TAG}${name}`)
    }else {
        performance.clearMeasures()
    }
}
reportCustomEventToGa(eventName, dataLayer){
  this.performanceAnalytics.gaEventTrigger(eventName, dataLayer)
}
}